import { useCallback, useEffect, useState } from 'react'
import { getUserFileReferenceForStandaloneViewer } from '../fetch/get-user-file-reference-for-standalone-viewer'
import { UserFileReferenceViewerResponse } from '../schema/userFileReferenceViewer.schema'

type UseUserFileReferenceState = {
  data: UserFileReferenceViewerResponse | null
  isLoading: boolean
  isError: boolean
  refetch: () => void
}

export function useUserFileReferenceInStandalone(referenceId: string, matterId: string): UseUserFileReferenceState {
  const [data, setData] = useState<UserFileReferenceViewerResponse | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)

  const fetchData = useCallback(async () => {
    if (!referenceId || !matterId) {
      setData(null)
      setIsError(true)
      return
    }

    setIsLoading(true)
    setIsError(false)

    try {
      const result = await getUserFileReferenceForStandaloneViewer(referenceId, matterId)
      setData(result)
    } catch {
      setData(null)
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }, [referenceId, matterId])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return {
    data,
    isLoading,
    isError,
    refetch: fetchData,
  }
}
